import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useLead } from "@/context/LeadContext";
import Icon from "@/components/Icon";
import { HERO_SLIDES } from "@/data/content";

export default function Hero() {
  const { openLead } = useLead();
  const navigate = useNavigate();
  const [idx, setIdx] = useState(0);
  const n = HERO_SLIDES.length;
  const go = useCallback((i) => setIdx((i + n) % n), [n]);

  useEffect(() => {
    const t = setInterval(() => setIdx((p) => (p + 1) % n), 6500);
    return () => clearInterval(t);
  }, [n]);

  const slide = HERO_SLIDES[idx];

  const primary = () => {
    if (slide.cta.type === "scroll") {
      const el = document.getElementById(slide.cta.target);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      navigate(slide.cta.target);
    }
  };

  return (
    <section className="hs" id="home" data-testid="hero">
      <div className="hs__bg">
        {HERO_SLIDES.map((s, i) => (
          <div
            key={i}
            className={`hs__slide ${i === idx ? "is-active" : ""}`}
            style={{ backgroundImage: `url(${s.img})` }}
          />
        ))}
        <div className="hs__veil" />
      </div>

      <div className="container hs__inner">
        <div className="hs__content" key={idx}>
          <span className="eyebrow hs__eyebrow">{slide.eyebrow}</span>
          <h1 className="hs__title display">
            {slide.title.map((t, i) => (
              <span key={i} className="hs__title-line">{t}</span>
            ))}
          </h1>
          <h2 className="hs__subtitle">{slide.subtitle}</h2>
          <p className="hs__text">{slide.text}</p>
          <div className="hs__actions">
            <button className="btn btn--green" onClick={primary} data-testid="hero-explore">
              {slide.cta.label} <Icon name="ArrowRight" size={16} />
            </button>
            <button className="btn btn--ghost" onClick={() => openLead("contact")} data-testid="hero-talk">
              <Icon name="Users" size={16} /> Talk to Our Team
            </button>
          </div>
        </div>

        <div className="hs__dots" data-testid="hero-dots">
          {HERO_SLIDES.map((_, i) => (
            <button
              key={i}
              className={`hs__dot ${i === idx ? "is-active" : ""}`}
              onClick={() => go(i)}
              aria-label={`Go to slide ${i + 1}`}
              data-testid={`hero-dot-${i}`}
            />
          ))}
        </div>
      </div>

      <div className="hs__minis">
        <div className="container hs__minis-row">
          <div className="hero__mini"><span className="hero__mini-ic"><Icon name="Heart" size={18} /></span><div><strong>Better Care</strong><em>For People</em></div></div>
          <div className="hero__mini"><span className="hero__mini-ic"><Icon name="MonitorSmartphone" size={18} /></span><div><strong>Smarter Technology</strong><em>For Providers</em></div></div>
          <div className="hero__mini"><span className="hero__mini-ic"><Icon name="Users" size={18} /></span><div><strong>Stronger Communities</strong><em>For Tomorrow</em></div></div>
        </div>
      </div>
    </section>
  );
}
